"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PrintIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "21",
  height: "23",
  viewBox: "0 0 21 23",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-416.000000, -125.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(417.000000, 126.000000)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(-1.000000, -1.000000)",
          fill: color,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            fillRule: "nonzero",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M9.71388889,2 L9.71388889,6 C9.71388889,6.40784105 9.40870074,6.74440158 9.01423919,6.79376686 L8.91388889,6.8 L5,6.8 L5,12 L16,12 L16,2 L9.71388889,2 Z M8.11358548,2.43359059 L5.49504486,5.2 L8.113,5.2 L8.11358548,2.43359059 Z M18,12 L19,12 C20.1045695,12 21,12.8954305 21,14 L21,21 C21,22.1045695 20.1045695,23 19,23 L2,23 C0.8954305,23 0,22.1045695 0,21 L0,14 C0,12.8954305 0.8954305,12 2,12 L3,12 L3,5.32579924 C3,5.11273371 3.06800972,4.90641227 3.19238165,4.73608834 L3.2736751,4.6384477 L7.36735925,0.312648464 C7.52924852,0.141579943 7.74536022,0.0340708314 7.97684219,0.00684513667 L8.09368416,0 L17,0 C17.5128358,0 17.9355072,0.38604019 17.9932723,0.883378875 L18,1 L18,12 Z M2,14 L2,21 L19,21 L19,14 L2,14 Z M16.6691895,16.7 C17.1110173,16.7 17.4691895,17.0581722 17.4691895,17.5 C17.4691895,17.907841 17.1640013,18.2444016 16.7695398,18.2937669 L16.6691895,18.3 L14.2287598,18.3 C13.786932,18.3 13.4287598,17.9418278 13.4287598,17.5 C13.4287598,17.092159 13.7339479,16.7555984 14.1284095,16.7062331 L14.2287598,16.7 L16.6691895,16.7 Z"
            })
          })
        })
      })
    })
  })]
});

PrintIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = PrintIcon;
exports.default = _default;